export default {
  // TranspositionModal.vue
  transpositionModal: {
    titleModify: 'Modify the song transposition',
    titleTranspose: 'Transpose the song',
    noticeDetected: 'I detected that the original key did not match your voice, so I pre-selected the key that seems most suitable. If you want to keep the original key or try another one, click on the buttons below.',
    noticeExplore: 'If you want to change the key, you can explore different possibilities by clicking on the buttons below.',
    infoTitle: 'To benefit from transposition suggestions adapted to your voice,',
    infoButton: 'Take the vocal range test',
    infoSubtitle: '(Highly recommended if you plan to sing later)',
    warningChangeProgress: 'Warning! If you change the transposition, it will affect your knowledge of the song and therefore your progress in the course.',
    warningVoiceMismatch: 'The selected key does not match your voice, you may have difficulty singing this song in this key.',
    warningPianoHarder: 'The piano part of the selected key is more difficult.',
    keepOriginalTone: 'Keep the original key',
    changeToOriginalTone: 'Change to the original key',
    transposeToTone: 'Transpose to {tonality} / {frenchNote}',
    stayOnCurrentTone: 'Stay on the current key',
    changeToAdvisedTone: 'Change to the recommended key',
    returnToOriginalTone: 'Return to the original key'
  },

  // TranspositionButton.vue
  transpositionButton: {
    tonalityLabel: 'Key',
    originalTonality: 'Original key',
    modifiedTonality: 'Modified key',
    transposeButton: 'Transpose',
    transposeButtonCompact: 'Transpose ({tonality})'
  },

  // AmbitusComparator.vue
  ambitusComparator: {
    songPart: 'The vocal part of the song',
    userRange: 'Your vocal range',
    low: 'Low',
    high: 'High'
  },

  // TranspositionSelector.vue
  transpositionSelector: {
    currentTonality: 'Current key',
    originalTonality: 'Original key',
    advised: 'recommended',
    advisedLabel: 'Recommended'
  },

  // note.ts
  notes: {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G'
  }
}